module.exports = __webpack_public_path__ + "img/component-bg.30a18e93.png";